export default class DataBuffer {
  constructor (data = undefined, hook = undefined) {
    this.data = data
    this.hook = hook
    this.delay = 1000
    this.idTimer = undefined
  }

  reset (getData = false) {
    if (this.idTimer) {
      clearTimeout(this.idTimer)
      this.idTimer = undefined
    }
    if (getData && this.data) {
      const result = this.data
      this.data = undefined
      return result
    }
  }

  set (data, hook) {
    this.data = data
    this.hook = hook
    this.start()
  }

  start () {
    this.reset()
    this.idTimer = setTimeout(this.tick.bind(this), this.delay)
  }

  tick () {
    let rslt
    const r = this.hook(this.data)
    if (r instanceof Promise) {
      r.then(result => { rslt = result }, err => { throw err })
    } else {
      rslt = r
    }
    this.idTimer = undefined
    this.data = undefined
    return rslt
  }

  flush () {
    if (this.idTimer) {
      this.reset()
      return this.tick()
    }
  }
}
